export const api_url = process.env.VUE_APP_BASE_API_URL;
